import { useSearchParams } from 'react-router';

type SetURLSearchParams = ReturnType<typeof useSearchParams>[1];
type MappedNumberValues<T extends string[]> = { [K in keyof T]: number | undefined };

export function useNumberSearchParams<T extends string[]>(...names: T): [...MappedNumberValues<T>, SetURLSearchParams] {
    const [searchParams, setSearchParams] = useSearchParams();

    const paramValues = names.map((name) => (searchParams.has(name) ? Number(searchParams.get(name)) : undefined)) as MappedNumberValues<T>;

    return [...paramValues, setSearchParams];
}
